import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public indexCard: InputSignal<number> = input.required<number>();
  public title: InputSignal<string> = input.required<string>()
  public img: InputSignal<string> = input.required<string>();
  public durationMinutes: InputSignal<number> = input.required<number>();
  public isDuration15Minutes: InputSignal<boolean> = input.required<boolean>();

  public isImgError: boolean = false;
  
  public handleImgError(): void {
    this.isImgError = true;
  }
}
